import styled from 'styled-components';

import { config } from 'config';
const color = config.theme?.header?.color ? config.theme.header.color : '#fff';

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  div {
    color: ${color};
    font-size: 15px;
    margin-left: 20px;
    margin-right: 10px;
  }
  img {
    cursor: pointer;
  }
  &:hover .menu11 {
    display: block;
  }
`;

export const Button = styled.button`
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #eee;
  border-radius: 10px;
  padding: 0 15px 0px 35px;
  background: #38414b url('/images/settings.svg') no-repeat 10px 50%;
  background-size: 20px;
  border: 0;
  cursor: pointer;
  margin: 0 5px 0 0;
  position: relative;
  .menu1 {
    position: absolute;
    display: none;
    right: 0;
    top: 26px;
    z-index: 99999;
    padding-top: 7px;
  }
  .menu1items {
    background: #38414b;
    border-radius: 10px;
    white-space: nowrap;
    display: block;
  }
  &:hover {
    .menu1 {
      display: block;
    }
  }
`;

export const Subbutton = styled.span`
  display: block;
  line-height: 1.3;
  font-size: 14px;
  color: #eee;

  padding: 8px 15px;
  background: #38414b;
  background-size: 20px;
  border: 0;
  text-align: right;
  cursor: pointer;
  margin: 0 0 1px;
  transition: 0.3s all ease-in;
  &.sb-all {
    border-radius: 10px;
  }
  &.sb-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  &.sb-bt {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  &:hover {
    background: #18212b;
  }
  &.sb-input{
    display: flex;
    align-items: center;
    line-height: normal;
    justify-content: flex-end;
  }
  input {
    cursor: pointer;
    margin: 0 10px 0 0;
  }
`;

export const LogoutButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 5px;

  color: #eee;
  border-radius: 10px;
  padding: 0 14px;
  border: 0;

  background: rgb(112, 118, 128);
  background-image: none;
`;
